<template>
  <div class="mfooter-container">
    <div class="logo">
        <img :src="logoUrl" alt="" srcset="">
        <span>华艺元界</span>
    </div>
    <ul class="contact">
        <h4>联系我们</h4>
        <li class="contact-item">
            <p><a href="">邮箱：im@huayiyuanjie@.xin</a></p>
            <p><a href="">电话：020-888888</a></p>
        </li>
    </ul>
    <ul class="flow">
        <h4 style="color: #000; font-weight: 600;">关注我们</h4>
        <li class="flow-item">
            <p><a style="color: #8c9198;" href="" @click="handleClick($event,'wechat')">微信公众号</a></p>
            <p><a style="color: #8c9198;" href="" @click="handleClick($event,'douyin')">抖音</a></p>
            <p><a style="color: #8c9198;" href="" @click="handleClick($event,'weibo')">微博</a></p>
        </li>
    </ul>
    <div class="cop">
        <p class="license">艺术品经营备案：120104180008</p>
        <p class="license">网安备: 津ICP备2024014758号-4</p>
        <p>Copyright © 2024 华艺元界. All Rights Reserved.</p>
    </div>
    <!-- 二维码弹窗 -->
    <div class="qr-modal" v-if="showQrCode">
      <div class="qr-content">
        <img :src="currentQrCode" alt="二维码" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      logoUrl: require('@/assets/imgs/logo.png'),
      showQrCode: false,
      currentQrCode: '',
      qrTimer: null
    }
  },
  methods: {
    handleClick(event, type) {
      // 阻止默认事件，防止页面刷新
      event.preventDefault()

      console.log('点击了', type)

      // 清除之前的定时器
      if (this.qrTimer) {
        clearTimeout(this.qrTimer)
      }

      // 设置当前二维码图片路径
      switch (type) {
        case 'wechat':
          this.currentQrCode = require('@/assets/about/gzh.jpg')
          break
        case 'douyin':
          this.currentQrCode = require('@/assets/about/dy.jpg')
          break
        case 'weibo':
          this.currentQrCode = require('@/assets/about/wb.jpg')
          break
        default:
          this.currentQrCode = ''
      }

      // 显示弹窗
      this.showQrCode = true

      // 2秒后自动隐藏弹窗
      this.qrTimer = setTimeout(() => {
        this.showQrCode = false
      }, 2000)
    }
  }
}
</script>

<style lang="less" scoped>
.mfooter-container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .logo {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 0;
    img {
        width: 35px;
        height: 35px;
        margin: 0 10px;
    }
    span {
        font-size: 32px;
        font-weight: 600;
        color: #333;
    }
  }
  .contact {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    li {
        line-height: 24px;
    }
  }
  .flow {
    padding: 10px 0 30px 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    box-sizing: border-box;
    li {
        line-height: 24px;
    }
    a {
      cursor: pointer;
      color: inherit;
      text-decoration: none;
      &:hover {
        color: #FF793A;
      }
    }
  }
 .cop {
    width: 100%;
    height: 100%;
    display: flex;
    color: #000;
    flex-direction: column;
    align-items: center;
    justify-content: center;
 }
}

/* 二维码弹窗样式 */
.qr-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  .qr-content {
    width: 50%;
    max-width: 300px;
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    text-align: center;

    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>